module.exports = __webpack_public_path__ + "img/yongdian2.fb099760.svg";